import { useContext } from 'react';

import { StatsContext } from '../context';

export const useStats = () => useContext(StatsContext);
